import React, { useState } from 'react'
import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  PartnerByIdPartners,
  PartnerByIdPartnersVariables,
} from '../../_generated/PartnerByIdPartners'

import { PartnerPosition } from '../../_generated/globalTypes'
export { PartnerPosition }

export const QUERY = gql`
query PartnerByIdPartners($id: ID!, $position: PartnerPosition!, $offset: Int!, $limit: Int!){
  partners {
    byId(id: $id) {
      id
      partners(position: $position, pagination: {offset: $offset, limit: $limit}) {
        id
        name
        position
        email
        type
        aggregated {
          balance
          equity
          deposited
          withdrawn
          currency
          profit
        }
        counts {
          sbibs
          bibs
          ibs
          clients
        }
      }
    }
  }
}`

export type Q = PartnerByIdPartners
export type V = PartnerByIdPartnersVariables
export type R = Q['partners']['byId']['partners']

export const parseData = (data: Q): R => {
  return get(data, p => p.partners.byId.partners)
}

export const parseMoreData = (prevResult: Q, fetchMoreResult: Q): Q => {
  if (!fetchMoreResult) return prevResult
  const partners = [...parseData(prevResult), ...parseData(fetchMoreResult)]
  const r: Q = JSON.parse(JSON.stringify(prevResult))
  r.partners.byId.partners = partners
  return r
}

type T = {
  partnerId: string
  limit: number
  offset: number
  position: PartnerPosition
}

export function Use<T>({ partnerId: id, limit, offset = 0, position }) {
  const [loadingMore, setLoadingMore] = useState(false)
  const query = useQuery<Q, V>(
    QUERY,
    {
      variables: {
        id,
        limit,
        offset,
        position
      }
    }
  )

  const { loading, error, data, fetchMore } = query
  const parsecData = parseData(data)

  type TM = {
    limit: number
  }

  const more = ({limit = 4}) => {
    setLoadingMore(true)
    
    fetchMore({
      variables: {
        offset: parsecData.length,
        limit
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        setLoadingMore(false)
        return parseMoreData(prev, fetchMoreResult)
      }
    })

    return () =>{}
}

  return { loading, error, data: parsecData, fetchMore, parseMoreData, more, loadingMore }
}
